import { render, staticRenderFns } from "./LiveAgentTicketNew.vue?vue&type=template&id=6f9471f0&scoped=true"
import script from "./LiveAgentTicketNew.vue?vue&type=script&lang=ts"
export * from "./LiveAgentTicketNew.vue?vue&type=script&lang=ts"
import style0 from "./LiveAgentTicketNew.vue?vue&type=style&index=0&id=6f9471f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9471f0",
  null
  
)

export default component.exports